import "./Home.css"
import InfiniteTrain from "./InfiniteTrain"
import Departures from "./Departures";
import Bakbord from "./graphics/Bakbord"

export default function Home(){
    return (
        <div className="Home">
            <header className="Home-header">

            </header>
            <Departures/>
        </div>
    )
}